<template>
  <!-- <v-text-field
    v-if="item"
    ref="textField"
    single-line
    outlined
    v-currency="options"
    @input="handleInput"
    class="input-amount"
    @keyup="calculateTotal()"
  /> -->
  <v-text-field
    v-if="item"
    ref="input"
    v-currency="options"
    :value="formattedValue"
    outlined
    dense
    v-bind="$attrs"
    @change="onChange"
    @input="onInput"
    class="input-amount"
    @keyup="calculateTotal()"
  />
  <v-text-field
    v-else
    ref="input"
    v-currency="options"
    :value="formattedValue"
    outlined
    dense
    v-bind="$attrs"
    @change="onChange"
    @input="onInput"
    class="input-amount"
  />
</template>

<script>
// import { setValue, parse } from 'vue-currency-input';

export default {
  name: 'amountField',
  props: {
    value: {
      type: Number,
      default: 0
    },
    item: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      formattedValue: null
    };
  },
  computed: {
    options() {
      return {
        locale: 'id',
        currency: null,
        distractionFree: false,
        precision: 0
      };
    }
  },
  watch: {
    value(value) {
      this.setValue(value);
    }
  },
  mounted() {
    this.setValue(this.value);
  },
  methods: {
    setValue(value) {
      this.$ci.setValue(this.$refs.input, value);
    },
    onInput(value) {
      this.$emit('input', this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    },
    onChange(value) {
      this.$emit('change', this.$ci.getValue(this.$refs.input));
      this.formattedValue = value;
    },
    // handleInput(value) {
    //   this.$emit('input', parse(value, this.options));
    // },
    calculateTotal() {
      this.item[12].value = 0;
      const total = this.item
        .filter(item => item.month !== 'Total')
        .reduce((prevValue, item) => {
          prevValue = +prevValue + +item.value;
          return prevValue;
        }, 0);
      this.item[12].value = total;
    }
  }
};
</script>

<style>
.input-amount input {
  text-align: right;
}
</style>
